import React from "react";

import { PageStructure } from "../../pages";
import { MapWithPolygons } from "../../components";

const LocationsMap = () => {
  return (
    <PageStructure>
      <h2>Locations Map</h2>
      <div className="locations-map-container">
        <MapWithPolygons />
      </div>
    </PageStructure>
  );
};
export default LocationsMap;